import React from 'react';

//components
import { ExternalLoginUserImage, UserProfileImages } from 'thrive-components';

//helpers
import { Truncate } from  '@/helpers/Text';
import { IUserIconAndName } from  '@/interfaces/orgSettings';



const UserIconAndName = ({profilePicture, userId, username, truncate, isManagedUser, externalLoginIcon} : IUserIconAndName) => {
    return (
        <span className='username-item'>
            {isManagedUser
                ?   <ExternalLoginUserImage
                        profileImageUrl={profilePicture}
                        providerIconUrl={externalLoginIcon}
                    />
                :   <UserProfileImages 
                        isSingleProfile 
                        imageUrl={[profilePicture]} 
                        imageCap={1}
                    /> 
            }            
            
            <a className='bolder-text user-link' href={`/admin/OrganizationUser/EditProfile/${userId}`}>{Truncate(username, truncate)}</a>
        </span>
    )
}

export default UserIconAndName